import { isEmpty } from '@ember/utils';
import { htmlSafe } from '@ember/template';
import { t } from 'i18n';
function getProductName(event) {
  const itemName = event.get('itemName');
  const variationName = event.get('variationName');
  if (isEmpty(itemName) && isEmpty(variationName)) {
    return null;
  } else if (isEmpty(itemName)) {
    return variationName;
  } else if (isEmpty(variationName)) {
    return itemName;
  } else {
    return `${itemName}, ${variationName}`;
  }
}
export function formatName(event) {
  if (isEmpty(event)) {
    return '';
  }
  const productName = getProductName(event);
  if (event.get('objectDeleted')) {
    return t('inventory2.history.events.deletedProductName', {
      productName: htmlSafe(productName)
    });
  } else {
    return productName || '';
  }
}